import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon, UserIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    id: 1,
    name: 'Priya S.',
    location: 'Bangalore',
    profession: 'Software Engineer',
    content: "I was popping sleeping pills every night for 6 months. The grogginess was killing my productivity at work. Switched to Setu's Sleep Restore strips 3 months ago—I sleep through the night and wake up actually refreshed. Game changer!",
    stars: 5,
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80'
  }, {
    id: 2,
    name: 'Rajesh M.',
    location: 'Mumbai',
    profession: 'Finance Professional',
    content: "My doctor suggested melatonin instead of stronger sleep meds. Setu's Sleep Restore strips work gently—I fall asleep in 30 minutes and don't feel drugged in the morning. The mint flavor is pleasant too. Finally sleeping like a normal person again.",
    stars: 5,
    image: 'https://images.unsplash.com/photo-1618151313441-bc79b11e5090?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80'
  }, {
    id: 3,
    name: 'Sneha K.',
    location: 'Delhi',
    profession: 'Marketing Manager',
    content: "Was skeptical about 'natural' solutions, but desperate enough to try. Three weeks with Sleep Restore strips, and my sleep cycle is completely normalized. The convenience of the strips is great for travel too. No dependency, no side effects, just good sleep.",
    stars: 5,
    image: 'https://images.unsplash.com/photo-1592124549776-a7f0cc973b24?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1587&q=80'
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const next = () => {
    setActiveIndex(current => current === testimonials.length - 1 ? 0 : current + 1);
  };
  const prev = () => {
    setActiveIndex(current => current === 0 ? testimonials.length - 1 : current - 1);
  };
  return <section className="w-full bg-gray-50 py-16 md:py-24" id="testimonials" data-id="element-516">
      <div className="container mx-auto px-4 md:px-6" data-id="element-517">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-12" data-id="element-518">
          Real People, Real Results
        </h2>
        <div className="max-w-4xl mx-auto relative" data-id="element-519">
          <div className="bg-white rounded-lg shadow-lg p-6 md:p-10" data-id="element-520">
            <div className="flex mb-4" data-id="element-521">
              {[...Array(testimonials[activeIndex].stars)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" fill="currentColor" data-id="element-522" />)}
            </div>
            <div className="flex flex-col md:flex-row" data-id="element-523">
              <div className="md:w-1/3 mb-6 md:mb-0 md:mr-8 flex justify-center" data-id="element-524">
                <div className="relative" data-id="element-525">
                  <div className="bg-indigo-100 rounded-full h-32 w-32 flex items-center justify-center border-4 border-indigo-100 shadow-md overflow-hidden" data-id="element-526">
                    <img src={testimonials[activeIndex].image} alt={testimonials[activeIndex].name} className="h-full w-full object-cover" onError={e => {
                    e.target.onerror = null;
                    e.target.parentNode.innerHTML = `<div class="h-32 w-32 bg-indigo-200 flex items-center justify-center"><span class="text-indigo-600 text-4xl font-bold">${testimonials[activeIndex].name.charAt(0)}</span></div>`;
                  }} data-id="element-527" />
                  </div>
                </div>
              </div>
              <div className="md:w-2/3" data-id="element-528">
                <blockquote className="text-gray-700 text-lg md:text-xl italic mb-6" data-id="element-529">
                  "{testimonials[activeIndex].content}"
                </blockquote>
                <div className="flex items-center" data-id="element-530">
                  <div data-id="element-531">
                    <p className="font-bold text-gray-900" data-id="element-532">
                      {testimonials[activeIndex].name}
                    </p>
                    <p className="text-gray-600" data-id="element-533">
                      {testimonials[activeIndex].location} (
                      {testimonials[activeIndex].profession})
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-6 space-x-4" data-id="element-534">
            <button onClick={prev} className="bg-white hover:bg-gray-100 text-indigo-600 p-2 rounded-full shadow-md transition-colors" aria-label="Previous testimonial" data-id="element-535">
              <ChevronLeftIcon className="h-6 w-6" data-id="element-536" />
            </button>
            <div className="flex space-x-2 items-center" data-id="element-537">
              {testimonials.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`h-2 w-2 rounded-full ${index === activeIndex ? 'bg-indigo-600' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-538" />)}
            </div>
            <button onClick={next} className="bg-white hover:bg-gray-100 text-indigo-600 p-2 rounded-full shadow-md transition-colors" aria-label="Next testimonial" data-id="element-539">
              <ChevronRightIcon className="h-6 w-6" data-id="element-540" />
            </button>
          </div>
        </div>
      </div>
    </section>;
};